import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-off-black border-t border-zinc-800 py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center text-muted-warm-grey text-xs sm:text-sm leading-relaxed">
          <p>
            © 2026 Leigh Witherell. All rights reserved.
            <span className="hidden sm:inline"> | </span>
            <span className="block sm:inline mt-1 sm:mt-0">
              Website Made by{' '}
              <a
                href="https://hinton-media.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-flesh-tone hover:underline transition-all duration-300"
              >
                Hinton Media
              </a>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
